import * as swcHelpers from '@swc/helpers';
import { MultiBancoFields } from '../models/details-order.js';

const toOrderDetailsPaymentInfo = (paymentDetails)=>{
    if (!paymentDetails || !paymentDetails.length || !paymentDetails[0]) {
        return undefined;
    }
    const { paymentMethodDetails  } = paymentDetails[0];
    return paymentMethodDetails ? Object.entries(paymentMethodDetails).reduce((acc, [key, value])=>{
        if (key !== '__typename') {
            return swcHelpers.objectSpread({}, acc, {
                [MultiBancoFields[key] || key]: value
            });
        }
        return acc;
    }, {}) : undefined;
};
const toOrderDetailPrice = (raw)=>{
    var ref, ref1;
    return swcHelpers.objectSpread({
        totalPrice: raw.final.gross,
        shippingMethodPrice: raw.shippingCost.gross || 0,
        paymentMethodPrice: raw.paymentCost.gross || 0,
        discountedAmount: raw.priceBeforeCosts.discount.amount || 0,
        subtotalAmount: raw.priceBeforeCosts.subtotal || 0,
        taxAmount: raw.final.tax.amount || 0,
        taxRate: ((ref = raw.final.tax.portions[0]) === null || ref === void 0 ? void 0 : ref.rate) || 0,
        shippingTaxRate: ((ref1 = raw.shippingCost.tax.portions[0]) === null || ref1 === void 0 ? void 0 : ref1.rate) || 0,
        shippingDiscount: raw.shippingCost.discount.amount || 0
    }, !!raw.donation && {
        donation: {
            amount: raw.donation,
            totalWithDonation: raw.finalWithDonation
        }
    }, {
        appliedDiscounts: raw.final.discount.appliedDiscounts.map((discount)=>({
                type: discount.type,
                value: discount.amount
            })
        )
    });
};
const toAddress = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'firstName',
        'lastName',
        'middleName',
        'additionalAddressInfo',
        'streetName',
        'salutation',
        'streetNumber',
        'additionalStreetInfo',
        'city',
        'title',
        'postalCode',
        'region',
        'pOBox',
        'state',
        'countryCode',
        'externalId',
        'company', 
    ];
    if (raw.__typename === 'OrderAddress') {
        return fieldNames.reduce((m, fieldName)=>{
            if (fieldName in raw) {
                var _fieldName;
                return swcHelpers.objectSpread({}, m, {
                    [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
                });
            }
            return m;
        }, {});
    }
};
const toCustomerDetails = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'email',
        'phone',
        'dateOfBirth',
        'IBAN'
    ];
    if (raw.__typename === 'OrderCustomerDetails') {
        return fieldNames.reduce((m, fieldName)=>{
            if (fieldName in raw) {
                var _fieldName;
                return swcHelpers.objectSpread({}, m, {
                    [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
                });
            }
            return m;
        }, {});
    }
};
const toOrderDeliveryMethod = (raw)=>{
    return raw.deliveryMethodName;
};
const toInvoice = (raw)=>{
    if (!raw) {
        return undefined;
    }
    return {
        customerCode: raw.code || undefined,
        secondaryEmail: raw.certifiedEmail || undefined,
        recipientCode: raw.certifiedRecipientCode || undefined,
        customerVatId: raw.vatId || undefined,
        insuranceProvider: raw.insuranceProvider || undefined,
        insuranceNumber: raw.insuranceNumber || undefined
    };
};
const toServiceStore = (raw)=>{
    if (!raw) {
        return undefined;
    }
    return {
        streetNumber: raw.streetNumber || undefined,
        streetName: raw.streetName || undefined,
        name: raw.name || undefined,
        code: raw.code
    };
};
const toDonationIntent = (raw)=>{
    var ref2;
    if (!raw) {
        return undefined;
    }
    const paymentWithDonationIntent = raw.find((payment)=>{
        var ref;
        return (ref = payment.donationIntent) === null || ref === void 0 ? void 0 : ref.foundationKey;
    });
    return paymentWithDonationIntent ? {
        foundationKey: (ref2 = paymentWithDonationIntent.donationIntent) === null || ref2 === void 0 ? void 0 : ref2.foundationKey
    } : undefined;
};

export { toAddress, toCustomerDetails, toDonationIntent, toInvoice, toOrderDeliveryMethod, toOrderDetailPrice, toOrderDetailsPaymentInfo, toServiceStore };
//# sourceMappingURL=orders.js.map
